module.exports = __webpack_public_path__ + "img/store-upgrade.8243fe1a.png";